import React from 'react';
import Logo from './Logo';
import Navigation from './Navigation';

const Header = () => {
    return (
        <header className="paddingtop">
            <Logo />
            <Navigation />
        </header>
    );
};

export default Header;